import { useEffect, useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import "../theme/motion.css";

/** Escritura y cursor magenta de ADALTRA; el texto completo conserva su espacio. */
function TitleRun({ text, dot, accent }) {
  const reducedMotion = useMediaQuery("(prefers-reduced-motion: reduce)");
  const [count, setCount] = useState(0);
  const letters = Array.from(text);
  const complete = reducedMotion || count >= letters.length;

  useEffect(() => {
    if (reducedMotion || !text.length) return undefined;
    const characters = Array.from(text);
    const interval = Math.max(14, Math.min(28, 1400 / characters.length));
    let timer;
    let index = 0;
    const advance = () => {
      index += 1;
      setCount(index);
      if (index < characters.length) {
        timer = window.setTimeout(advance, interval);
      }
    };
    timer = window.setTimeout(advance, 120);
    return () => window.clearTimeout(timer);
  }, [text, reducedMotion]);

  const visible = complete ? text : letters.slice(0, count).join("");
  const remaining = complete ? "" : letters.slice(count).join("");
  const tail = /\S*$/.exec(visible)?.[0] ?? "";
  const head = visible.slice(0, visible.length - tail.length);
  const accentAt = accent ? text.lastIndexOf(accent) : -1;
  const colored = (value, offset = 0) => {
    if (accentAt < 0 || offset + value.length <= accentAt) return value;
    const split = Math.max(0, accentAt - offset);
    return <>{value.slice(0, split)}<span className="adl-title-accent">{value.slice(split)}</span></>;
  };
  return <span className="adl-animated-title" data-state={complete ? "done" : "typing"}>
    <span className="adl-sr-only">{text}{dot ? "." : ""}</span>
    <span aria-hidden="true">{colored(head)}<span className="adl-title-tail">{colored(tail, head.length)}
      {(!complete || dot) && <span className="adl-title-cursor" data-done={complete ? "" : undefined}>{complete ? "." : "/"}</span>}
    </span><span className="adl-title-ghost">{colored(remaining, visible.length)}</span></span>
  </span>;
}

export function AnimatedTitle({ text, dot = true, accent, brandMarks = false }) {
  const content = brandMarks ? text.replace(/\.$/, "") : text;
  return <>{brandMarks && <span className="adl-title-prefix" aria-hidden="true">/ </span>}
    <TitleRun key={content} text={content} accent={accent?.replace(/\.$/, "")} dot={dot && (brandMarks || !/[.!?]$/.test(text))} />
  </>;
}
